import { getMultiFactorResolver, PhoneAuthProvider, PhoneMultiFactorGenerator } from "firebase/auth";
import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useAuthContext } from "../../../auth/useAuthContext";
import VerifyCodeForm from "./VerifyCodeForm";
import LoginLayout from "../../../layouts/login/LoginLayout";

export default function VerifyCode(){
    const [verificationCode, setVerificationCode] = useState("");
    const [storedResolver, setStoredResolver] = useState();
    const [redactedPhone, setRedactedPhone] = useState('');
    const {auth} = useAuthContext();
    
    useEffect(()=>{
        try{

            setVerificationCode(sessionStorage.getItem("verificationId"));
            const jsonError = sessionStorage.getItem("mfaRequiredError");
            const error = JSON.parse(jsonError);
            const resolver = getMultiFactorResolver(auth, error);
            setStoredResolver(resolver);
            setRedactedPhone(resolver.hints[0].phoneNumber);
        } catch(error){
            sessionStorage.removeItem('mfaRequiredError');
            sessionStorage.removeItem('verificationId');
            console.log(error);
        }
    },[])



    const submitCode = (code) => {
        const prom = new Promise((resolve, reject)=>{
              try{    
                const cred = PhoneAuthProvider.credential(verificationCode, code)                
                const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
                storedResolver.resolveSignIn(multiFactorAssertion)
                .then((userCredentials) =>{
                  console.log('login successful', userCredentials);
                  const user = userCredentials.user;
                  sessionStorage.removeItem('mfaRequiredError');
                  sessionStorage.removeItem('verificationId');
                    resolve('success');
                }).catch((error)=>{
                  console.log(error);
                  reject(error);
                });
    
              } catch(error){
                console.log(error);
              }
        })
        return prom;
    }

    return(
        <LoginLayout>
            <Typography sx={{ color: 'text.secondary' }}>
            We have texted a 6-digit confirmation code to {redactedPhone}, please enter the code below to login.
          </Typography>
          <VerifyCodeForm onSub={submitCode}/>                    
        </LoginLayout>
    )
    
    

}